import { AxiosError } from 'axios';
import { Nullable } from 'utils/types';
import { createState } from '../core';
import { Action, ACTION_TYPES, State } from './types';
import { Cases } from '../../api/casesListing/types';
import { CaseError } from 'modules/cm/domain/Case/Error';
import { store } from '../subPages';

const initialState = createState<Cases, Nullable<AxiosError>, Nullable<CaseError>>(
  {
    cases: [],
  },
  null,
  null,
  store.initialState,
);

const reducer = (state: State = initialState, action: Action) => {
  const map = new Map([
    [
      ACTION_TYPES.SUCCESS.toString(),
      () => ({ ...state, isPending: false, isLoaded: true, data: action.payload[0], error: action.payload[1] }),
    ],
    [ACTION_TYPES.ERROR.toString(), () => ({ ...state, isPending: false, isLoaded: true, error: action.payload[1] })],
    [ACTION_TYPES.PENDING.toString(), () => ({ ...state, isPending: true, isLoaded: false, error: null })],
  ]);

  const actionCallback = map.get(action.type);

  return actionCallback ? actionCallback() : state;
};

export default reducer;
